import React from "react";
import { Container, Table } from "react-bootstrap";
import "jspdf-autotable";
import HeaderPage from "../HeaderPage";
export default function SwarnandhraContactPage() {
  return (
    <>
    <HeaderPage/>
      <Container>
        <div className='contact-head'>
          <h3>Contact Details</h3>
        </div>
        <div className='table-responsive'>
          <Table className='contact-table bordered'>
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Officer Name</th>
                <th>Designation</th>
                <th>Departments/HoDs allotted</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="6" class="text-center">1</td>
                <td rowspan="6" class="text-center">
                  <span>Sanke Nagaraju<br></br>9885008868</span>
                </td>
                <td rowspan="6" class="text-center">
                  Liaison Officer
                </td>
                <td>I. Agriculture Marketing &amp; Co-Operation Secretariat</td>
              </tr>
              <tr>
                <td>II. Animal Husbandry, Dairy Development &amp; Fisheries Secretariat</td>
              </tr>
              <tr>
                <td>III. Food &amp; Civil Supplies Secretariat</td>
              </tr>
              <tr>
                <td>IV. Skill Development, Entrepreneurship and Innovation Secretariat</td>
              </tr>
              <tr>
                <td>V. Energy and Infrastructure Secretariat</td>
              </tr>
              <tr>
                <td>VI. Environment, Forest, Science &amp; Technology Secretariat</td>
              </tr>
              <tr>
                <td rowSpan="7" className="text-center">2</td>
                <td rowSpan="7" className="text-center">
                  <span>N.V.S. Manikanta<br />9989484536</span>
                </td>
                <td rowSpan="7" className="text-center">
                  Liaison Officer
                </td>
                <td>I. Finance Secretariat</td>
              </tr>
              <tr>
                <td>II. Chief Electoral Officer Secretariat</td>
              </tr>
              <tr>
                <td>III. Health, Medical &amp; Family Welfare Secretariat</td>
              </tr>
              <tr>
                <td>IV. Higher Education Secretariat</td>
              </tr>
              <tr>
                <td>V. Home Secretariat</td>
              </tr>
              <tr>
                <td>VI. Housing Secretariat</td>
              </tr>
              <tr>
                <td>VII. Industries and Commerce Secretariat</td>
              </tr>
              <tr>
                <td rowSpan="6" className="text-center">3</td>
                <td rowSpan="6" className="text-center">
                  <span>Dhanashri Ramesh Zilpe<br />7066504395</span>
                </td>
                <td rowSpan="6" className="text-center">
                  Liaison Officer
                </td>
                <td>I. Infrastructure and Investment Secretariat</td>
              </tr>
              <tr>
                <td>II. Information Technology, Electronics and Communications Secretariat</td>
              </tr>
              <tr>
                <td>III. Labour and Employment Secretariat</td>
              </tr>
              <tr>
                <td>IV. Law Secretariat</td>
              </tr>
              <tr>
                <td>V. Municipal Administration and Urban Development Secretariat</td>
              </tr>
              <tr>
                <td>VI. Panchayat Raj and Rural Development Secretariat</td>
              </tr>
              <tr>
                <td rowSpan="11" className="text-center">4</td>
                <td rowSpan="11" className="text-center">
                  <span>Ch. Srinu<br />8309781397</span>
                </td>
                <td rowSpan="11" className="text-center">
                  Liaison Officer
                </td>
                <td>I. Planning Secretariat</td>
              </tr>
              <tr>
                <td>II. Revenue Secretariat</td>
              </tr>
              <tr>
                <td>III. Secondary Education Secretariat</td>
              </tr>
              <tr>
                <td>IV. Transport, Roads and Buildings Secretariat</td>
              </tr>
              <tr>
                <td>V. Water Resources Secretariat</td>
              </tr>
              <tr>
                <td>VI. Women, Children, Disabled and Senior Citizens Secretariat</td>
              </tr>
              <tr>
                <td>VII. Youth and Sports Secretariat</td>
              </tr>
              <tr>
                <td>VIII. Social Welfare Secretariat</td>
              </tr>
              <tr>
                <td>IX. Tribal Welfare Secretariat</td>
              </tr>
              <tr>
                <td>X. Minorities Welfare Secretariat</td>
              </tr>
              <tr>
                <td>XI. Backward Classes Welfare Secretariat</td>
              </tr>
              <tr>
                <td className="text-center">5</td>
                <td className="text-center">
                  <span>S. Mounika, APCFSS<br />80088 62087</span>
                </td>
                <td className="text-center">
                  Technical
                </td>
                <td>
                  Technical Support related to the Portal
                  <br />
                  <strong>(Support Hours: 10:00 AM – 5:30 PM)</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div className='table-description'>
          <p>All official communication related to KPI updates, clarifications, and submissions must be sent to the following <strong>email ID:</strong> swarnaandhra_kpis@apcfss.in</p>
        </div>
      </Container>
      <footer className='fixed-footer'>
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-xxl-6 col-lg-6 col-md-12 col-xl-6 col-sm-6 col-xs-12 mt-5 mb-3 mt-md-5 mb-md-5 map">
                <iframe
                  title="Andhra Pradesh Secretariat Location"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15301.026931424183!2d80.5143899!3d16.5131316!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35ed8c10624dd1%3A0xd1b09f85f6e6b3da!2sAndhra%20Pradesh%20Secretariat!5e0!3m2!1sen!2sin!4v1725365218335!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div class="col-xxl-6 col-lg-6 col-md-12 col-xl-6 col-sm-6 col-xs-12 mb-5 mt-0 mb-sm-auto mt-sm-auto footer-right">
                <div class="footer-head">
                  <h4 class="text-whitee mb-3 contrasttext">
                    Get in <span>Touch</span>
                  </h4>
                  <div class="addresses">
                    <p><span>Planning Department</span><br></br>2nd Block,1st Floor<br />
                      AP Secretariat, Velagapudi,<br />
                      Amaravathi.<br />
                      Andhra Pradesh, Pin Code- 522503</p>
                    <p>9392911819, 08645-277702</p>
                  </div>
                </div>

              </div>
            </div>
            <div className='disclaimer text-center d-none'>
              <h5>Disclaimer</h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sed purus ac diam elementum venenatis at et augue. Quisque a magna vulputate, luctus nunc at, vehicula massa. Quisque fermentum odio et magna aliquam, in rhoncus metus accumsan. Quisque condimentum nibh ut turpis consectetur rutrum.</p>
            </div>

          </div>


          <div class="bottom text-center p-2">
            <p class="mb-0 text-white">Designed and Developed by<a href="https://apcfss.in/" target='_blank'><img src="images/footer-img.webp" className="footer-img footer-brand-logo" alt="" /></a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}